import { api } from './api';

export const apiAccessApi = api.injectEndpoints({
  endpoints: (builder) => ({
    listApiKeys: builder.query({
      query: () => ({
        url: 'api-access/keys',
        method: 'GET',
      }),
      providesTags: ['ApiKeys'],
    }),
    createApiKey: builder.mutation({
      query: ({ label, userId }) => ({
        url: 'api-access/keys',
        method: 'POST',
        body: { label, userId },
      }),
      invalidatesTags: ['ApiKeys'],
    }),
    revokeApiKey: builder.mutation({
      query: ({ keyId }) => ({
        url: 'api-access/keys/revoke',
        method: 'POST',
        body: { keyId },
      }),
      invalidatesTags: ['ApiKeys'],
    }),
    getApiAccessLog: builder.query<unknown, { limit?: string; apiKeyId?: string } | void>({
      query: ({ limit, apiKeyId } = {}) => {
        const params = new URLSearchParams();
        if (limit) params.append('limit', limit);
        if (apiKeyId) params.append('apiKeyId', apiKeyId);
        return {
          url: `api-access/log?${params.toString()}`,
          method: 'GET',
        };
      },
    }),
    getEligibleKeyUsers: builder.query({
      query: () => ({
        url: 'api-access/eligible-users',
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useListApiKeysQuery,
  useCreateApiKeyMutation,
  useRevokeApiKeyMutation,
  useGetApiAccessLogQuery,
  useGetEligibleKeyUsersQuery,
} = apiAccessApi;
